import { cn } from "cn";
import { Slider } from "@/components/ui/slider/slider";

export default function SliderWithTicks({
  skipInterval,
  customTicks,
  ...props
}: React.ComponentProps<typeof Slider> & {
  skipInterval: number;
  customTicks?: number[];
}) {
  const step = props.step || 1;
  const max = props.max || 10;
  const ticks =
    customTicks || [...Array(max / step + 1)].map((_, i) => i * step);

  return (
    <div className="flex flex-col gap-2">
      <Slider aria-label="Slider with ticks" {...props} />
      <span
        className="flex w-full items-center justify-between gap-1 px-2 "
        aria-hidden="true"
      >
        {ticks.map((tick, i) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length tick marks derived from step/max (or a static customTicks list), never reorder
            key={i}
            className="flex w-0 flex-col items-center justify-center"
          >
            <span
              className={cn(
                /* sorted */
                "h-1 w-px bg-bg-dark-high",
                i % skipInterval !== 0 && "h-0.5",
              )}
            />
            <span
              className={cn(
                /* sorted */
                "font-normal text-sm leading-5 text-text-dark-high",
                i % skipInterval !== 0 && "opacity-0",
              )}
            >
              {tick}
            </span>
          </span>
        ))}
      </span>
    </div>
  );
}
